module.exports = __webpack_public_path__ + "static/media/11.dc9b4f2b.png";